import { useEffect } from 'react';
import { supabase } from '../../supabaseClient';

// Mantém values.vehicle/vehicle_name do orçamento em sincronia com o cadastro
// do veículo. Cobre troca de veículo no select, edição do veículo no modal
// (reload) e vehicle_name desnormalizado defasado no orçamento carregado —
// sem isto o PDF (que lê vehicle_name) mostrava o veículo antigo até fechar
// e reabrir o orçamento.
// Usado pelos dois ModalBudgetContainer (orçamento e orçamento da OS).
export const useSyncBudgetVehicle = ({ values, setValues, reload }) => {
  const selectedVehicleId = values?.vehicle?.value || values?.vehicle;

  useEffect(() => {
    if (!selectedVehicleId) return;
    let cancelled = false;

    const refreshSelectedVehicle = async () => {
      const { data, error } = await supabase
        .from('Vehicle')
        .select('id, plate, model')
        .eq('id', selectedVehicleId)
        .single();
      if (cancelled || error || !data) return;

      const label = `${data.plate} / (${data.model})`;
      setValues((prev) => {
        const prevId = prev?.vehicle?.value || prev?.vehicle;
        if (prevId !== data.id) return prev;
        if (prev.vehicle_name === label && prev?.vehicle?.label === label) {
          return prev;
        }
        return {
          ...prev,
          vehicle: { value: data.id, label },
          vehicle_name: label,
        };
      });
    };

    refreshSelectedVehicle();
    return () => {
      cancelled = true;
    };
  }, [selectedVehicleId, reload, setValues]);
};
